import React, { useEffect, useCallback, useState, useRef } from "react";
import { FaCheckCircle, FaInfoCircle } from "react-icons/fa";
import { Link, useParams } from "react-router-dom";
import {
  showToast,
  formatDateWithDayjs,
  getRelativeTime
} from "../../../../utils/utils";
import Gravatar from "react-gravatar";
import "../../accessmanagement.scss";
import { showToastType } from "../../../../utils/constants/appConstants";
import {
  addSalesLead,
  createPricingPlan,
  viewUser
} from "../../../../locales/en";
import { userManagementUsersURL } from "../../../../utils/constants/apiEndPoints";
import privateAxios from "../../../../utils/axiosPrivate";

export default function UserOverview() {
  const { userId } = useParams();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const initialRender = useRef(true);

  const fetchUser = useCallback(async () => {
    try {
      const response = await privateAxios.get(userManagementUsersURL(userId));
      setUser(response.data.data);
    } catch (error) {
      showToast(error.response.data.message, showToastType.error);
    } finally {
      setLoading(false);
    }
  }, [userId, privateAxios]);

  useEffect(() => {
    if (initialRender.current) {
      fetchUser();
      initialRender.current = false;
    }
  }, [fetchUser]);

  if (loading) {
    return (
      <div className="spinner-wrap bg-light">
        <div className="spinner-border custom-spinner-color" />
      </div>
    );
  }

  if (!user) {
    return (
      <div className="spinner-wrap bg-light">
        <div className="spinner-border custom-spinner-color" />
      </div>
    );
  }
  const getStatusClass = (value) =>
    value === true
      ? "text-success border-success"
      : "text-danger border-danger";
  const getStatusText = (value) =>
    value === true ? createPricingPlan.active : createPricingPlan.inactive;
  const getConfirmedText = (value) =>
    value === "true" || value === true
      ? createPricingPlan.propertyOptions.item1
      : createPricingPlan.propertyOptions.item2;
  const getConfirmedPh = (value) =>
    value === "true" || value === true ? <FaCheckCircle /> : <FaInfoCircle />;
  const getConfirmedPhClass = (value) =>
    value === "true" || value === true ? "text-success" : "text-danger";

  return (
    <div className="col-md-12 sale-leade-form Acces_mngmnt mt-3">
      <form>
        <div className="row mb-3">
          <div className="col-sm-4">
            <div className="input-title">
              <label htmlFor="profilePic">{viewUser.profilePic}</label>
            </div>
          </div>
          <div className="col-sm-8">
            <div className="view_user">
              <Gravatar
                email={user.primaryEmail}
                size={100}
                rating="pg"
                default="wavatar"
                className="img-thumbnail"
              />
            </div>
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-sm-4">
            <div className="input-title">
              <label htmlFor="fullName">{addSalesLead.fullName}</label>
            </div>
          </div>
          <div className="col-sm-8">
            <div className="view_user">
              {user.firstName} {user.middleName} {user.lastName}
            </div>
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-sm-4">
            <div className="input-title">
              <label htmlFor="mailAddrs">{addSalesLead.mailAddrs}</label>
            </div>
          </div>
          <div className="col-sm-8">
            <div className="view_user">
              <Link to={`mailto:${user.primaryEmail}`}>
                {user.primaryEmail}
              </Link>
            </div>
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-sm-4">
            <div className="input-title">
              <label htmlFor="emailConfirmed">{viewUser.emailConfirmed}</label>
            </div>
          </div>
          <div className="col-sm-8">
            <div className="view_user">
              <span
                className={`${getStatusClass(user.isConfirmed)} border badge rounded-pill`}
              >
                {getConfirmedText(user.isConfirmed)}
              </span>
            </div>
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-sm-4">
            <div className="input-title">
              <label htmlFor="addSalesLead">{addSalesLead.number}</label>
            </div>
          </div>
          <div className="col-sm-8">
            <div className="view_user">
              <Link to={`tel:${user.primaryContactNumber}`}>
                {user.primaryContactNumber}
              </Link>
              {` `}
              <span
                className={`${getConfirmedPhClass(user.isPrimaryContactValidated)}`}
              >
                {getConfirmedPh(user.isPrimaryContactValidated)}
              </span>
            </div>
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-sm-4">
            <div className="input-title">
              <label htmlFor="accountStatus">{viewUser.accountStatus}</label>
            </div>
          </div>
          <div className="col-sm-8">
            <div className="view_user">
              <span
                className={`${getStatusClass(user.isActive)} border badge rounded-pill`}
              >
                {getStatusText(user.isActive)}
              </span>
            </div>
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-sm-4">
            <div className="input-title">
              <label htmlFor="createdAt">{viewUser.createdAt}</label>
            </div>
          </div>
          <div className="col-sm-8">
            <div className="view_user">
              {`${formatDateWithDayjs(user.createdAt)} (${getRelativeTime(user.createdAt, "DD-MMM-YYYY hh:mm A")})`}
            </div>
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-sm-4">
            <div className="input-title">
              <label htmlFor="lastUpdatedAt">{viewUser.lastUpdatedAt}</label>
            </div>
          </div>
          <div className="col-sm-8">
            <div className="view_user">
              {`${formatDateWithDayjs(user.updatedAt)} (${getRelativeTime(user.updatedAt, "DD-MMM-YYYY hh:mm A")})`}
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}
